import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { faMagnifyingGlass, faXmark } from '@fortawesome/free-solid-svg-icons';
import { Catalog, CatalogConcept, CatalogOperation } from '../../services/processings.service';

const SCOPE_CONCEPTS = ['escopo_campo', 'escopo_documento'];

function normalize(value: string): string {
  return (value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

@Component({
  selector: 'app-processing-catalog',
  standalone: true,
  imports: [CommonModule, FormsModule, FontAwesomeModule, TranslateModule],
  templateUrl: './processing-catalog.component.html',
  styleUrls: ['./processing-catalog.component.scss'],
})
export class ProcessingCatalogComponent {
  icons = { faMagnifyingGlass, faXmark };

  @Input() catalog: Catalog | null = null;
  @Input() catalogError: string | null = null;
  @Output() retry = new EventEmitter<void>();

  search = '';

  get operations(): CatalogOperation[] {
    return (this.catalog?.operations ?? []).filter(op => op.type !== 'pending');
  }

  get filtered(): CatalogOperation[] {
    const term = normalize(this.search);
    if (!term) {
      return this.operations;
    }
    return this.operations.filter(op =>
      normalize(op.title).includes(term) ||
      normalize(op.summary).includes(term) ||
      normalize(op.id).includes(term)
    );
  }

  clearSearch(): void {
    this.search = '';
  }

  get scopes(): CatalogConcept[] {
    const concepts = this.catalog?.concepts ?? [];
    return SCOPE_CONCEPTS
      .map(id => concepts.find(concept => concept.id === id))
      .filter((concept): concept is CatalogConcept => !!concept);
  }
}
